(function () {
  'use strict';

  var toggle = document.getElementById('MobileMenuToggle');
  var nav = document.getElementById('MobileNav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function () {
    var isOpen = !nav.hidden;
    nav.hidden = isOpen;
    toggle.setAttribute('aria-expanded', String(!isOpen));
    document.body.classList.toggle('pf-nav-open', !isOpen);
  });

  nav.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      nav.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('pf-nav-open');
    });
  });
})();
